import React from 'react';
import { motion } from 'framer-motion';
const HOTMART = 'https://pay.hotmart.com/O103704589E';
export function ClosingSection() {
  return <section className="bg-gray-900 text-white py-20 md:py-28 px-4" data-id="element-45">
      <div className="container mx-auto max-w-2xl text-center" data-id="element-46">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-serif font-bold mb-6 leading-tight" data-id="element-47">
          🌿 Reiki no te está buscando
          <br className="hidden md:block" data-id="element-48" /> por casualidad
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-lg md:text-xl text-gray-400 mb-12 leading-relaxed" data-id="element-49">
          No necesitás más información. Necesitás un sistema que te acompañe y
          te sostenga.
        </motion.p>

        <motion.a href={HOTMART} target="_blank" rel="noopener noreferrer" whileHover={{
        scale: 1.03
      }} whileTap={{
        scale: 0.97
      }} className="inline-block px-10 py-5 bg-gradient-to-r from-amber-500 via-yellow-500 to-amber-500 text-black font-extrabold text-xl md:text-2xl rounded-full shadow-[0_0_30px_rgba(245,158,11,0.5)] hover:shadow-[0_0_50px_rgba(245,158,11,0.7)] transition-all mb-6" data-id="element-50">
          👉 Accedé ahora al MegaPack Reiki
        </motion.a>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="text-base text-amber-300/80 italic" data-id="element-51">
          La sanación ya está en vos. Solo necesitás activarla ✨
        </motion.p>
      </div>
    </section>;
}